import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-3 px-4 md:px-6">
      <ol className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
        <li>
          <Link to="/" className="hover:text-primary-600 transition-colors">
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-foreground-300" />
            {item.href ? (
              <Link
                to={item.href}
                className={`hover:text-primary-600 transition-colors ${
                  index === items.length - 1 ? 'text-foreground-700 font-medium' : ''
                }`}
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}